import { createStructuredSelector, createSelector } from "reselect"

export const selectPositionFromProps = (state, props) => props.position

export const makePositionSelector = (key) =>
    createSelector(selectPositionFromProps, (position) => position && position.get && position.get(key))

export const selectNotReviewed = createSelector(
    selectPositionFromProps,
    (position) => position && position.has && position.has("reviewed") && !position.get("reviewed")
)

export const selectIsArchived = createSelector(
    makePositionSelector("archived"),
    makePositionSelector("priority"),
    makePositionSelector("stance"),
    selectNotReviewed,
    (archived, priority, stance, notReviewed) => archived || priority === 0 || stance === 0 || notReviewed
)

export const selectUpdatedDate = createSelector(
    makePositionSelector("updated"),
    (positionUpdatedDate) => positionUpdatedDate
)

export const positionAdderConnection = createStructuredSelector({
    isArchived: selectIsArchived,
    updatedDate: selectUpdatedDate,
})
